import React from 'react';
import apiUser from "../../apiUser";
import Link from "../Application/Link";
import {useTecRmi} from "../../contexts/TecRmiContext";
import classnames from "classnames";
import {isEmpty} from "lodash";

const PrintButton = () => {
  const {printData} = useTecRmi()

  if(isEmpty(printData)){
    return null
  }

  return <Link
    className={classnames({
      'btn btn-light mr-2': true,
      'btn-disabled': !printData?.path
    })}
    to={apiUser.tecRmi.print({
      endpoint: printData.path,
      params: printData.params
    })}
    tooltip="Drukuj"
    target="_blank"
  >
    <i className="fas fa-print" />
  </Link>
};

PrintButton.propTypes = {

};

export default PrintButton;